// Meta Pixel utility — initializes Facebook Pixel and exposes event tracking helpers.

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '1459456665403886'
const PIXEL_SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

let initialized = false

function loadPixelScript(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  // Stub fbq so calls before the script loads are queued
  const fbq: any = function (...args: any[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue.push(args)
    }
  }
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  // Inject the script
  const script = document.createElement('script')
  script.async = true
  script.src = PIXEL_SCRIPT_SRC
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (initialized) return

  try {
    loadPixelScript()
    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
    initialized = true
  } catch (err) {
    // Silently fail so pixel issues never break the page
    console.warn('[MetaPixel] init failed:', err)
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  } catch (err) {
    console.warn('[MetaPixel] track failed:', err)
  }
}

export function trackAddToCart(params?: Record<string, any>): void {
  trackEvent('AddToCart', {
    content_name: 'VISIONGOL — Acceso Privado',
    content_ids: ['visiongol-access'],
    content_type: 'product',
    currency: 'USD',
    value: 6.36,
    ...params,
  })
}
